








import { defineComponent } from '@nuxtjs/composition-api';
import { Option } from '~/components/BikeFinder/questions';

export default defineComponent({
  name: 'AnswerOption',
  props: {
    option: { default: {} },
    selected: { type: Boolean, default: false },
  },
  setup(props) {
    // eslint-disable-next-line
    const iconPath = require(`static/bikefinder/${(props.option as Option).icon}?raw`);
    return { iconPath };
  },
});
